import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { PublicClientApplication } from "@azure/msal-browser";
import { getFunctions } from "firebase/functions";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAmm1hpW-2wEv1xVqRB8CK5l8RSEXZblpQ",
  authDomain: "quantum-6c796.firebaseapp.com",
  projectId: "quantum-6c796",
  storageBucket: "quantum-6c796.appspot.com",
  appId: "1:254505298820:web:b9e5fab7ad19248e4e8bd1",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app);

// Export the app object along with db and auth
export { app, db, auth, functions };

// Microsoft Graph API (MSAL) Config
const msalConfig = {
  auth: {
    clientId: "20028a03-acd2-44ed-8d8e-de9b194fe3db", // From the app with http://localhost:3000/auth/callback
    authority: "https://login.microsoftonline.com/common", // Multi-tenant for personal accounts
    redirectUri: "http://localhost:3000/auth/callback",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const initializedMsalInstance = msalInstance
  .initialize()
  .then(() => msalInstance);
